export default __webpack_public_path__ + "static/media/geetee.e4efcb37.png";